import { Pipe, PipeTransform } from '@angular/core'
import dayjs from 'dayjs'

import { dateFormats } from '@app/core/constants/dateFormats'
import { AuthService } from '@app/modules/auth/auth.service'
import { UtilityService } from '@app/core/services/utility.service'

import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

@Pipe({
  name: 'dayjsDate',
  standalone: false,
})
export class DayjsDatePipe implements PipeTransform {
  constructor(
    private readonly authService: AuthService,
    private readonly utilityService: UtilityService,
  ) {}

  transform(date?: string): string {
    // const dateFormat = this.authService.getCurrentUserDateFormat() || dateFormats.date
    // return this.utilityService.dayjsDateTimeFormatting(date, dateFormat)

    if (!date) return ''
    const storedTimezone = localStorage.getItem('storedTimezone')
    const parsedTimezone = storedTimezone ? JSON.parse(storedTimezone) : null
    const userTimezone = parsedTimezone?.name || dayjs.tz.guess()

    const dateFormat = dateFormats.date
    return dayjs(date).tz(userTimezone).format(dateFormat)
  }
}

@Pipe({
  name: 'DayjsPureDate',
  standalone: false,
})
export class DayjsPureDatePipe implements PipeTransform {
  constructor(private readonly authService: AuthService) {}

  transform(date?: string): string {
    const dateFormat = `${this.authService.getCurrentUserDateFormat()} HH:mm:ss` || dateFormats.fullTime

    return date ? dayjs.utc(date).format(dateFormat) : null
  }
}
